import { ReactNode } from 'react';
import cn from 'classnames';

import classes from './inline-message.module.scss';
import { InlineMessageType } from './inline-message.types';
import { InlineMessageIcon } from './inline-message-icon';

export type TInlineMessageProps = {
  text: ReactNode,
  content?: ReactNode
  type: InlineMessageType,
  classNameText?: string,
  classNameTextWrapper?: string
  classNameContent?: string,
};


const InlineMessage = (props: TInlineMessageProps) => {
  return (
    <article className={cn(classes.root, classes[props.type])}>
      <header className={cn(classes.classNameTextWrapper, props.classNameTextWrapper)}>
        <InlineMessageIcon type={props.type} />
        <span className={cn(classes.text, props.classNameText)}>
          {props.text}
        </span>
      </header>
      <footer className={cn(classes.content, props.classNameContent)}>
        {props.content}
      </footer>
    </article>
  )
};

InlineMessage.defaultProps = {
  type: InlineMessageType.SUCCESS
}

export { InlineMessage };
